import { cashRegister } from '../util/route/menu/cash-register';
import { healthMonitor } from '../util/route/menu/health-monitor';
import { home } from '../util/route/menu/home';
import { statistics } from '../util/route/menu/statistics';
import { createUserMenu } from '../util/route/menu/user';
import { useAppSelector } from './useAppSelector';

export const useMenus = () => {
  const username = useAppSelector((state) => state.configSlice.username);

  return [home, statistics, cashRegister, healthMonitor, createUserMenu(username)];
};
